import { IconButton } from '@chakra-ui/react';
import { ICON_CREATED } from 'constants/mixpanel';
import { WidgetDragDropWrapper } from 'modules/Editor/components/WidgetDragDrop';
import { WidgetType } from 'types/widget.types';
import { E1_ICON_ID_TO_LINE_ICON_TYPE_MAP } from 'widgets/Lines/LineIconWidget/LineIconWidget.config';
import { generateDefaultData } from 'widgets/Lines/LineIconWidget/LineIconWidget.helpers';
import { LineIconWidgetData } from 'widgets/Lines/LineIconWidget/LineIconWidget.types';
import { LINE_TYPE_MAP } from 'widgets/Lines/LineIconWidget/Lines';
import { ArrowStyleTypes } from 'widgets/Lines/common/CommonLine.types';

import { ICON_PREVIEW_SIZE } from './IconWidgetMenu.config';

const PREVIEW_SCALE = 0.8;
const PREVIEW_STROKE = 4;

interface LineIconPreviewProps {
  id: string;
  disableDragDrop?: boolean;
  onClick?: (type: WidgetType, data: Partial<LineIconWidgetData>) => void;
}

export const LineIconPreview = ({ id, onClick, disableDragDrop }: LineIconPreviewProps) => {
  const lineData = E1_ICON_ID_TO_LINE_ICON_TYPE_MAP[id];
  const widgetDragDropData = lineData ? generateDefaultData(lineData.type, lineData.data) : null;
  const Line = LINE_TYPE_MAP[lineData?.type];
  const handleClick = () => {
    if (!lineData || !lineData.data || !lineData.type) return;

    const { type, data } = lineData;
    onClick?.(WidgetType.LineIcon, { ...data, type });
  };
  if (!lineData || !Line || !widgetDragDropData) {
    return null;
  }

  const { widthPx, heightPx, strokeDashType, startArrowStyle, endArrowStyle } = lineData.data;
  return (
    <WidgetDragDropWrapper
      isDraggable={!disableDragDrop}
      widgetData={widgetDragDropData}
      type={WidgetType.LineIcon}
      trackingEventData={{
        event_name: ICON_CREATED.eventName,
        properties: {
          from: ICON_CREATED.from.Search,
          icon_id: id,
        },
      }}
    >
      <IconButton
        width={`${ICON_PREVIEW_SIZE}px`}
        height={`${ICON_PREVIEW_SIZE}px`}
        p={2}
        icon={
          <Line
            widthPx={widthPx! * PREVIEW_SCALE}
            heightPx={heightPx! * PREVIEW_SCALE}
            strokeColor='#000'
            strokeWidth={PREVIEW_STROKE}
            strokeDashType={strokeDashType || 'solid'}
            startArrowStyle={startArrowStyle || ArrowStyleTypes.none}
            endArrowStyle={endArrowStyle || ArrowStyleTypes.none}
            id={id}
          />
        }
        aria-label={'Add line icon'}
        onClick={handleClick}
        variant='icon-btn-side-menu'
      />
    </WidgetDragDropWrapper>
  );
};
